import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { useRefFrom } from "@faire/web--source/ui/hooks/useRefFrom";
import { observer } from "mobx-react";
import qs from "query-string";
import React, { Suspense, useCallback, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { TrackedLinkContext } from "@faire/retailer/components/TrackedLink";
import { useCartProductAddOptions } from "@faire/retailer/features/ProductAdd/useCartProductAddOptions";
import { LazyQuickAddModal } from "@faire/retailer/features/ProductQuickAddModal/LazyQuickAddModal";
import { useCartItems } from "@faire/retailer/hooks/cart/useCartItems";
import { useCartUpdate } from "@faire/retailer/hooks/cart/useCartUpdate";
import { AddToCartVariants } from "@faire/retailer-visitor-shared/stores/domain/CartStore/triggerAddToCartEvent";
import { ProductTileRoundQuantityOptionPicker } from "@faire/retailer/views/brand/carousels/ProductTileRoundQuantityOptionPicker";
import { BulkUpdateItemClass } from "@faire/retailer/views/brand/utils/bulkUpdateCartItem";
import { FaireProtectionTooltip } from "../BrandCartCard/components/FaireProtectionTooltip";
var preventClickEvents = function(e) {
    e.preventDefault();
    e.stopPropagation();
};
var EncapsulatedQuickAddBase = function(_param) {
    var productToken = _param.productToken, quickAdd = _param.quickAdd, brandToken = _param.brandToken, imageContainerRef = _param.imageContainerRef, updateItems = _param.updateItems, onQuickAddClick = _param.onQuickAddClick, onQuickAddSubmit = _param.onQuickAddSubmit, onChooseOption = _param.onChooseOption, onChooseOptionQuantityUpdate = _param.onChooseOptionQuantityUpdate, showModalOnClick = _param.showModalOnClick, renderCollapsableQuickAddButtonProps = _param.renderCollapsableQuickAddButtonProps, disableQuickAddWithFaireProtectionTooltip = _param.disableQuickAddWithFaireProtectionTooltip, className = _param.className, getCartItemTokenByProductToken = _param.getCartItemTokenByProductToken, rest = _object_without_properties(_param, [
        "productToken",
        "quickAdd",
        "brandToken",
        "imageContainerRef",
        "updateItems",
        "onQuickAddClick",
        "onQuickAddSubmit",
        "onChooseOption",
        "onChooseOptionQuantityUpdate",
        "showModalOnClick",
        "renderCollapsableQuickAddButtonProps",
        "disableQuickAddWithFaireProtectionTooltip",
        "className",
        "getCartItemTokenByProductToken"
    ]);
    var _quickAdd_quick_add_option, _quickAdd_quick_add_option1, _quickAdd_quick_add_option2;
    var PRODUCT_TILE_PICKER_WIDTH = 32;
    var PRODUCT_TILE_PICKER_OFFSET = 8;
    var PRODUCT_TILE_PICKER_OFFSET_LARGE = 16;
    var _useState = _sliced_to_array(useState(PRODUCT_TILE_PICKER_WIDTH), 2), clientWidth = _useState[0], setClientWidth = _useState[1];
    var getProductTileQuantityInCart = useCartItems().getProductTileQuantityInCart;
    var updateCartItemsWithUpdateHandler = useCartUpdate().updateCartItemsWithUpdateHandler;
    var context = useContext(TrackedLinkContext);
    var history = useHistory();
    useEffect(function() {
        var _getWindow;
        var handleResize = debounceIfPossible(function() {
            var _imageContainerRef_current;
            var _imageContainerRef_current_clientWidth;
            setClientWidth((_imageContainerRef_current_clientWidth = imageContainerRef === null || imageContainerRef === void 0 ? void 0 : (_imageContainerRef_current = imageContainerRef.current) === null || _imageContainerRef_current === void 0 ? void 0 : _imageContainerRef_current.clientWidth) !== null && _imageContainerRef_current_clientWidth !== void 0 ? _imageContainerRef_current_clientWidth : PRODUCT_TILE_PICKER_WIDTH);
        }, 200);
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener("resize", handleResize);
        };
    }, [
        imageContainerRef
    ]);
    var _useState1 = _sliced_to_array(useState(false), 2), isEncapsulatedQuickAddModalOpen = _useState1[0], setIsEncapsulatedQuickAddModalOpen = _useState1[1];
    var cartQuantity = getProductTileQuantityInCart(productToken !== null && productToken !== void 0 ? productToken : "");
    var onChooseMultiOption = function() {
        var _getCartItemTokenByProductToken;
        var findByToken = (_getCartItemTokenByProductToken = getCartItemTokenByProductToken === null || getCartItemTokenByProductToken === void 0 ? void 0 : getCartItemTokenByProductToken(productToken !== null && productToken !== void 0 ? productToken : "")) !== null && _getCartItemTokenByProductToken !== void 0 ? _getCartItemTokenByProductToken : "";
        if (findByToken !== "") {
            history.replace(_object_spread_props(_object_spread({}, history.location), {
                search: qs.stringify(_object_spread_props(_object_spread({}, qs.parse(history.location.search)), {
                    findByToken: findByToken,
                    updateQuantityOnChange: "true"
                }))
            }));
            setIsEncapsulatedQuickAddModalOpen(true);
        } else {
            setIsEncapsulatedQuickAddModalOpen(true);
        }
    };
    var productAddOptionsQuickAdd = useCartProductAddOptions(updateItems);
    var _useRefFrom = useRefFrom(function() {
        var _context_containerName;
        return new BulkUpdateItemClass(updateItems !== null && updateItems !== void 0 ? updateItems : updateCartItemsWithUpdateHandler, (_context_containerName = context === null || context === void 0 ? void 0 : context.containerName) !== null && _context_containerName !== void 0 ? _context_containerName : "collection_page");
    }), bulkUpdateItemHelper = _useRefFrom.current;
    var _quickAdd_quick_add_option_option_unit_multiplier, _quickAdd_quick_add_option_option_min_order_quantity, _quickAdd_quick_add_option_option_available_units;
    var internalRenderCollapsableQuickAddButtonProps = _object_spread({
        value: 0,
        stepSize: (_quickAdd_quick_add_option_option_unit_multiplier = quickAdd === null || quickAdd === void 0 ? void 0 : (_quickAdd_quick_add_option = quickAdd.quick_add_option) === null || _quickAdd_quick_add_option === void 0 ? void 0 : _quickAdd_quick_add_option.option_unit_multiplier) !== null && _quickAdd_quick_add_option_option_unit_multiplier !== void 0 ? _quickAdd_quick_add_option_option_unit_multiplier : 0,
        onChange: function(value) {
            var _quickAdd_quick_add_option;
            onQuickAddClick === null || onQuickAddClick === void 0 ? void 0 : onQuickAddClick(value);
            var _quickAdd_quick_add_option_option_token;
            bulkUpdateItemHelper.bulkUpdateItems(productToken !== null && productToken !== void 0 ? productToken : "", (_quickAdd_quick_add_option_option_token = quickAdd === null || quickAdd === void 0 ? void 0 : (_quickAdd_quick_add_option = quickAdd.quick_add_option) === null || _quickAdd_quick_add_option === void 0 ? void 0 : _quickAdd_quick_add_option.option_token) !== null && _quickAdd_quick_add_option_option_token !== void 0 ? _quickAdd_quick_add_option_option_token : "", value, (quickAdd === null || quickAdd === void 0 ? void 0 : quickAdd.quick_add_option) === undefined, brandToken !== null && brandToken !== void 0 ? brandToken : "", AddToCartVariants.ENCAPSULATED_QUICK_ADD_BTN, function() {
                return onQuickAddSubmit === null || onQuickAddSubmit === void 0 ? void 0 : onQuickAddSubmit(value);
            });
        },
        minValue: (_quickAdd_quick_add_option_option_min_order_quantity = quickAdd === null || quickAdd === void 0 ? void 0 : (_quickAdd_quick_add_option1 = quickAdd.quick_add_option) === null || _quickAdd_quick_add_option1 === void 0 ? void 0 : _quickAdd_quick_add_option1.option_min_order_quantity) !== null && _quickAdd_quick_add_option_option_min_order_quantity !== void 0 ? _quickAdd_quick_add_option_option_min_order_quantity : 0,
        maxValue: (_quickAdd_quick_add_option_option_available_units = quickAdd === null || quickAdd === void 0 ? void 0 : (_quickAdd_quick_add_option2 = quickAdd.quick_add_option) === null || _quickAdd_quick_add_option2 === void 0 ? void 0 : _quickAdd_quick_add_option2.option_available_units) !== null && _quickAdd_quick_add_option_option_available_units !== void 0 ? _quickAdd_quick_add_option_option_available_units : Number.MAX_SAFE_INTEGER,
        isMultiOption: (quickAdd === null || quickAdd === void 0 ? void 0 : quickAdd.quick_add_option) === undefined,
        onChooseMultiOption: onChooseMultiOption,
        multiOptionText: quickAdd === null || quickAdd === void 0 ? void 0 : quickAdd.quick_add_text,
        showModalOnClick: showModalOnClick
    }, renderCollapsableQuickAddButtonProps);
    var onCloseModal = useCallback(function() {
        setIsEncapsulatedQuickAddModalOpen(false);
    }, []);
    var handleOnClick = function() {
        if (internalRenderCollapsableQuickAddButtonProps.isMultiOption) {
            if (internalRenderCollapsableQuickAddButtonProps.onChooseMultiOption) {
                internalRenderCollapsableQuickAddButtonProps.onChooseMultiOption();
            }
            onChooseOption && onChooseOption();
        }
    };
    var renderQuickAddModal = function() {
        if (productToken && isEncapsulatedQuickAddModalOpen) {
            return /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazyQuickAddModal, {
                    onClose: onCloseModal,
                    onChooseOptionQuantityUpdate: onChooseOptionQuantityUpdate,
                    productToken: productToken,
                    productAddOptions: productAddOptionsQuickAdd,
                    updateCartFn: updateItems
                }, "".concat(productToken, "-lazy-quick-add-modal"))
            });
        }
        return null;
    };
    var renderRoundQuantityPicker = function() {
        if (disableQuickAddWithFaireProtectionTooltip) {
            return /*#__PURE__*/ _jsx(FaireProtectionTooltip, {
                hidden: false,
                targetNode: /*#__PURE__*/ _jsx(ProductTileRoundQuantityOptionPicker, _object_spread_props(_object_spread({}, internalRenderCollapsableQuickAddButtonProps), {
                    value: cartQuantity,
                    maxWidth: // either use container width or use the picker width
                    clientWidth - (showModalOnClick ? PRODUCT_TILE_PICKER_OFFSET_LARGE : PRODUCT_TILE_PICKER_OFFSET),
                    disabled: true
                })),
                usePortal: true,
                portalTooltipYOffset: REACT_PORTAL_TOOLTIP_Y_OFFSET
            });
        }
        return /*#__PURE__*/ _jsx(ProductTileRoundQuantityOptionPicker, _object_spread_props(_object_spread({}, internalRenderCollapsableQuickAddButtonProps), {
            value: cartQuantity,
            maxWidth: // either use container width or use the picker width
            clientWidth - (showModalOnClick ? PRODUCT_TILE_PICKER_OFFSET_LARGE : PRODUCT_TILE_PICKER_OFFSET)
        }));
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            renderQuickAddModal(),
            /*#__PURE__*/ _jsx(RoundQuantityPickerWrapper, _object_spread_props(_object_spread({
                className: className,
                onClick: function(e) {
                    preventClickEvents(e);
                    handleOnClick();
                },
                $isMultiOption: !!internalRenderCollapsableQuickAddButtonProps.isMultiOption,
                "data-test-id": "quick-add-marketplace-product",
                $showModalOnClick: showModalOnClick
            }, rest), {
                children: renderRoundQuantityPicker()
            }), "".concat(productToken, "-round-quantity-picker"))
        ]
    });
};
export var EncapsulatedQuickAdd = observer(EncapsulatedQuickAddBase);
export var RoundQuantityPickerWrapper = styled.div.withConfig({
    componentId: "sc-8b68bc00-0"
})([
    "position:absolute;bottom:8px;right:8px;z-index:5;"
]);
var REACT_PORTAL_TOOLTIP_Y_OFFSET = -4;
